import NobuVideoFrame from "../objects/nobu-video-frame";
import { selectedElementAll } from "../utils/element-handlers.utils";

function VideoFrameComponent(videoFrameElement: HTMLElement) {
    new NobuVideoFrame(videoFrameElement, videoFrameElement.getAttribute('data-video-frame') === 'controls')
}

export default function initVideoFrameComponent() {
    selectedElementAll('div.n-video-frame[data-video-frame]', VideoFrameComponent);
}
